// Common emoji icons for spaces, tags, etc.
export const SPACE_ICONS = [
  '💕', '👥', '📚', '💪', '📖', '✈️', '💼', '🚀', '🏠', '🎓',
  '🏃', '🍳', '🎬', '🎵', '📷', '🎮', '⚽', '🎸', '🎨', '🏥',
  '🌳', '🏖️', '🎯', '🔥', '⭐', '💎', '🌟', '🎪', '🏆', '🌍',
]

export const TAG_ICONS = [
  '📌', '📖', '📝', '🎓', '📋', '🏃', '🏋️', '🚴', '🥗', '😴',
  '💑', '✈️', '🍜', '🎂', '🏠', '💼', '📦', '📅', '✅', '📊',
  '💡', '🗺️', '🏨', '🏛️', '🚂', '💻', '🧪', '🚀', '📄', '⭐',
  '✍️', '🎵', '🎬', '📷', '🎨', '💪', '🧘', '☕', '🍷', '🛍️',
  '💇', '🛒', '👥', '🏥', '🧹', '🎮', '📺', '💬', '💧', '🚶',
  '🚇', '😴', '🌳', '🎁', '🔥', '🌍', '⚽', '🏀', '🎯', '🎪',
  '🏆', '💎', '🌟', '🎵', '🎸', '🎹', '🎤', '🎧', '🎬', '📚',
  '🔑', '📦', '🗂️', '📎', '🔖', '🏷️', '💰', '🧮', '📐', '🛠️',
]
